// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"5420f41a","977":"1bb12ded"}[chunkId] + ".chunk.js";
};